module.exports = __webpack_public_path__ + "ec6b59e351b1f8431ed0fa00e29b539b.jpg";